/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Application_Phase_TitleInputs */

const en_admin_application_phase_title = /** @type {(inputs: Admin_Application_Phase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration phases`)
};

const de_admin_application_phase_title = /** @type {(inputs: Admin_Application_Phase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldephasen`)
};

/**
* | output |
* | --- |
* | "Registration phases" |
*
* @param {Admin_Application_Phase_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_application_phase_title = /** @type {((inputs?: Admin_Application_Phase_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Application_Phase_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_application_phase_title(inputs)
	return en_admin_application_phase_title(inputs)
});